import Tooltip from "@mui/material/Tooltip";
import { byMatch, cleanTools, isMyTool, toolKey } from "components/Screens/Marketplace/Customer/utils/tools";
import useToolLogos from "components/Screens/Marketplace/Customer/utils/useToolLogos";
// The tooltip is the profile page's Hidden chip tip (.hidden-chip-tip)
import "components/Screens/Marketplace/Customer/common/Withheld/Withheld.scss";
import "./ToolChips.scss";

/** Prototype topTools: up to three on a card, the customer's own tools first. */
export const CARD_TOOLS = 3;

interface Props {
  /** The talent's tools as recorded; duplicates and generic tools are dropped. */
  tools?: string[];
  /** The tools to match: shown first with a purple border. */
  myTools?: string[];
  /** For the match tooltip: "Asad already works in Dentrix. Nice match." */
  firstName?: string;
  limit?: number;
}

/**
 * A talent's tools on cards and shortlists (prototype .tools / .chip / .chip.match): each a pill with the tool's logo,
 * or its name where there is none, the name on hover (the profile's Hidden chip tip); a matched tool is outlined in
 * purple and the tip says so.
 */
function ToolChips({ tools = [], myTools = [], firstName, limit = CARD_TOOLS }: Props) {
  const logos = useToolLogos();
  const shown = byMatch(cleanTools(tools), myTools).slice(0, limit);
  if (!shown.length) return null;
  return (
    <div className="tool-chips">
      {shown.map((t) => {
        const match = isMyTool(t, myTools);
        const logo = logos.get(toolKey(t));
        const tip = match ? `${firstName ? `${firstName} already works` : "Already works"} in ${t}. Nice match.` : "";
        return (
          <Tooltip
            key={t}
            // Text only: the match line, or the app's name
            title={tip || t}
            placement="top"
            enterTouchDelay={0}
            leaveTouchDelay={4000}
            slotProps={{ tooltip: { className: "hidden-chip-tip" } }}
          >
            <span
              className={`tool-chips__chip${match ? " tool-chips__chip--match" : ""}${logo ? " tool-chips__chip--logo" : ""}`}
              aria-label={tip || t}
            >
              {logo ? <img src={logo} alt="" className="tool-chips__logo" /> : t}
            </span>
          </Tooltip>
        );
      })}
    </div>
  );
}

export default ToolChips;
